import { render, staticRenderFns } from "./personaliza.vue?vue&type=template&id=1755ff60&scoped=true"
import script from "./personaliza.vue?vue&type=script&lang=js"
export * from "./personaliza.vue?vue&type=script&lang=js"
import style0 from "./personaliza.vue?vue&type=style&index=0&id=1755ff60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755ff60",
  null
  
)

export default component.exports